/*
 * File: 404.tsx
 * Project: a-a
 * File Created: Wednesday, 2nd April 2025 3:15:04 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Wednesday, 2nd April 2025 3:48:50 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Chip, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from '../../theme/Color';
import { Link } from 'react-router-dom';
import RoutePaths from '../../routes/RoutePaths';

const ErrorComponent = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      {' '}
      <Link to={RoutePaths.Home}>
        <img
          src={'/assets/logo.png'}
          alt='logo'
          width={'75px'}
          height={'48px'}
          style={{ top: '60px', left: '60px', position: 'absolute' }}
        />
      </Link>
      <Box sx={{ display: 'flex', gap: '120px' }}>
        <img src={'/assets/404.png'} alt='logo' width={'453px'} height={'299px'} style={{}} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '40px',
            // alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography sx={{ fontWeight: 700, fontSize: '51px' }}>Oops!</Typography>
          <Typography sx={{ fontWeight: 400, fontSize: '20px' }}>
            We can't seem to find the page you're looking for.
          </Typography>
          <Box
            sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
            color={zeplinColor.Neutral8}
          >
            <Typography sx={{ fontWeight: 400, fontSize: '20px' }}>
              Here are some helpful links instead:
            </Typography>
            <Box sx={{ display: 'flex', gap: '10px' }}>
              {['Login', 'Dashboard', 'Clients', 'Team'].map((val) => (
                <Link
                  to={
                    val === 'Dashboard'
                      ? RoutePaths.Home
                      : val === 'Clients'
                      ? RoutePaths.Client
                      : RoutePaths[val as keyof typeof RoutePaths]
                  }
                >
                  <Chip
                    label={
                      <Typography
                        variant='body3'
                        color={zeplinColor.BasicBlack}
                        sx={{
                          textAlign: 'center',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        {val}
                      </Typography>
                    }
                    sx={{
                      backgroundColor: zeplinColor.Neutral3,
                      padding: '15px 24px 15px 24px',
                      borderRadius: '50px',
                      // width: '47px',
                      height: '48px',
                      '& .MuiChip-label': {
                        padding: '0px',
                      },
                    }}
                  />
                </Link>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ErrorComponent;
